

import axios from 'axios'

export const baseURL = 'https://www.app-dev.api.myeasytransfer.com/v1'
export const baseURLSocket = 'https://www.app-dev.api.myeasytransfer.com'

// export const baseURL = 'https://www.api.myeasytransfer.com/v1'
// export const baseURLSocket = 'https://www.api.myeasytransfer.com'

const axiosInstance = axios.create({
  baseURL,
  timeout: 20000,
})

export default axiosInstance
